var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFF4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0039 12.3281V25.1615M19.2539 21.9531L22.0039 25.1615L24.7539 21.9531",
    stroke: "#F79009",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5846 18.7422C28.5784 18.7532 29.6582 18.8421 30.3622 19.5461C31.168 20.3519 31.168 21.648 31.168 24.2404V25.157C31.168 27.7503 31.168 29.0464 30.3622 29.8522C29.5574 30.657 28.2603 30.657 25.668 30.657H18.3346C15.7423 30.657 14.4452 30.657 13.6404 29.8522C12.8346 29.0455 12.8346 27.7503 12.8346 25.157V24.2404C12.8346 21.648 12.8346 20.3519 13.6404 19.5461C14.3444 18.8421 15.4242 18.7532 17.418 18.7422",
    stroke: "#F79009",
    strokeWidth: 1.58,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/Login-icon.b1ccf9142e15a3ba2a3205daefb6718b.svg";
export { ForwardRef as ReactComponent };